import React,{ useState, useEffect } from 'react';
import Spinner from 'react-bootstrap/Spinner';
import { formatCurrency } from '../services/formatservice';


export const PreviousHorse = (props) => {
  const [data, setdata] = useState([]);
  const [loaded, setloaded] = useState(false);

  useEffect(() => {
    if(props.data.length !== 0) {
      setdata(props.data);
      setloaded(true);
    }
  }, [props]);

  function info() {
    if(data.last_sold.hipnr) {
      return(
        <>
          <h2 className='toppadding'>#{data.last_sold.hipnr} {data.last_sold.horsename}</h2>
          <div className='break'></div>
          <ul className='bottompadding'>
            <li><b>Pris:</b> {formatCurrency(data.last_sold.price)}</li>
            <li><b>Köpare:</b> {data.last_sold.buyer}</li>
          </ul>
        </>
      )
    }
    return(<></>);
  }

  let content = loaded
    ? info()
    : <Spinner/>;

    return(
      <>
        {content}
      </>
    );
}